import React from 'react';
import { Container, type ContainerProps } from 'react-bootstrap';

export const PageMainContainer = ({ className, ...props }: ContainerProps) => {
  return <Container className={`m-0 p-0 p-sm-1 p-lg-3 ${className ?? ''}`} fluid {...props} />;
};
